import { CheckCircledIcon } from '@radix-ui/react-icons';
import { Button } from 'components/ui/button';
import { useChartConfig } from 'hooks/useChartConfig';
import { useModal } from 'hooks/useModal';
import { useService } from 'hooks/useService';
import { useToast } from 'hooks/useToast';
import { useMutation, useQueryClient } from 'react-query';
import { ContentType } from 'services/abstract';

export const ChartActionButtons = () => {
  const queryClient = useQueryClient();
  const { hideModal } = useModal();
  const { chart, pageCartoId } = useChartConfig();
  const { addToast } = useToast();
  const chartService = useService(ContentType.CHARTS);

  const { mutateAsync: submitChart, isLoading } = useMutation({
    mutationFn: async () => {
      const {
        id,
        indicators = [],
        created_at,
        updated_at,
        ...chartPayload
      } = chart;
      const payload = {
        ...chartPayload,
        indicators,
      };
      return id
        ? await chartService.updateChart(id, payload)
        : await chartService.createChart(payload);
    },
    onSuccess: () => {
      hideModal();
      addToast({
        title: `Graphique`,
        type: 'success',
        description: `Le graphique a été sauvegardé avec succès`,
      });
      queryClient.invalidateQueries({
        queryKey: ['page-carto-charts', pageCartoId],
      });
    },
    onError: (error) => {
      addToast({
        title: 'Echec lors de la sauvegarde du graphique',
        type: 'error',
        description: JSON.stringify(error),
      });
    },
  });

  return (
    <div className="relative">
      <Button
        isLoading={isLoading}
        icon={CheckCircledIcon}
        onClick={() => submitChart()}
        disabled={isLoading}
        size="sm"
      >
        Valider
      </Button>
    </div>
  );
};
